// extracted by mini-css-extract-plugin
export default {"headerleft":"HeaderLeft_headerleft__U0nIJ"};